import { render, staticRenderFns } from "./ConcernWomanOverview.vue?vue&type=template&id=98fb9d7e"
import script from "./ConcernWomanOverview.vue?vue&type=script&lang=js"
export * from "./ConcernWomanOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports